module.exports = __webpack_public_path__ + "media/images/suppliers/suppliers-icon-01-bad09258e01e1eca40839f794b38e910.svg";